import { render } from "./AddService.vue?vue&type=template&id=d7554340&ts=true"
import script from "./AddService.vue?vue&type=script&lang=ts"
export * from "./AddService.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__